export { getCommunicationSessionIdFrom } from './get-communication-session-id-from/get-communication-session-id-from';
export { getTaskQueueIds } from './get-task-queue-ids/get-task-queue-ids';
////////////////////////////////////////////////////////////////////////////////////////////////
// Warning On Import
////////////////////////////////////////////////////////////////////////////////////////////////

console.warn('--------- pwp-common:objects/communication/helper/index.ts: Imported ---------');
